const removeSpecialCharcters = text => text.replace(/[^\w\s]/gi, '');
const removeNumbers = text => text.replace(/[0-9]/g, '');
const removeLetters = text => text.replace(/\D/g, '');
const removeSpace = text => text.split(' ').join('');

const handleAcceptNumbers = text => {
  let formattedText = removeSpace(text);
  formattedText = removeSpecialCharcters(formattedText);
  formattedText = removeLetters(formattedText);
  return formattedText;
};
const handleAcceptLetters = text => {
  let formattedText = removeSpecialCharcters(text);
  formattedText = removeNumbers(formattedText);
  return formattedText;
};

const handleAcceptOneSpaceBetweenStrings = text => {
  const splittedString = text.split(' ');
  return splittedString
    .filter((value, index) => {
      if (value) {
        return value;
      }
      // if space not at first && previous string not space then its ok to add space
      else if (index != 0 && splittedString[index - 1]) {
        return ' ';
      }
    })
    .join(' ');
};
const cardNumberFormatter = text => {
  const formattedText = handleAcceptNumbers(text);
  return formattedText;
};

const nameOnCardFormatter = text => {
  let formattedText = handleAcceptLetters(text);
  formattedText = handleAcceptOneSpaceBetweenStrings(formattedText);
  return formattedText;
};

const cvvFormater = text => {
  const formattedText = handleAcceptNumbers(text);
  return formattedText;
};
const expirationDataFormatter = text => {
  const formattedText = handleAcceptNumbers(text);
  if (formattedText.length === 4 && !formattedText.includes('/')) {
    return formattedText.substring(0, 2) + '/' + formattedText.substring(2);
  }
  return formattedText;
};

export {
  handleAcceptOneSpaceBetweenStrings,
  cardNumberFormatter,
  expirationDataFormatter,
  cvvFormater,
  nameOnCardFormatter,
};
